import type { TFunction } from "i18next"
import React, { createContext, useContext } from "react"

import { useAppContext } from "@contexts/app_context"
import i18next from "@utils/localization"

type DashboardPageContextProps = {
  translate: TFunction<"translation", undefined>
}

const defaultValues: DashboardPageContextProps = {
  translate: i18next.t
}

const DashboardPageContext = createContext(defaultValues)

export function DashboardPageContextProvider(props: {
  children: React.ReactNode | React.ReactNode[]
}) {
  const { translate } = useAppContext()

  return (
    <DashboardPageContext.Provider
      value={{
        ...defaultValues,
        translate
      }}
    >
      {props.children}
    </DashboardPageContext.Provider>
  )
}

export function useDashboardPageContext() {
  const context = useContext(DashboardPageContext)
  if (context === undefined) {
    throw new Error("DashboardPage Context Error")
  }
  return context
}
